import React from "react"
import Head from "next/head"
import type { MetaHTMLAttributes } from "react"

interface MetaTag {
  id: number
  name?: string
  content?: string
  property?: string
  [key: string]: string | number | undefined
}

interface LayoutProps {
  children: React.ReactNode
  metaTags?: MetaTag[]
  title?: string
  showZendeskHelp?: boolean
  richSnippets?: React.ReactNode[]
}

const loadZendeskAsync = () => {
  var head = document.getElementsByTagName("head")[0]
  var script = document.createElement("script")
  script.type = "text/javascript"
  script.src =
    "https://static.zdassets.com/ekr/snippet.js?key=32138264-9917-46b0-9a60-ea00de440cb9"
  script.id = "ze-snippet"
  head.appendChild(script)
}

const Layout: React.FC<LayoutProps> = ({
  children,
  metaTags = [],
  title = "CitizenShipper",
  showZendeskHelp,
  richSnippets = [],
}) => {
  React.useEffect(() => {
    let loadZenDesk = document.querySelector('[data-zendesk="true"]')
    if (loadZenDesk) {
      setTimeout(() => {
        loadZendeskAsync()
      }, 2000)
    }
  }, [])

  return (
    <>
      <Head>
        {title && <title>{title}</title>}
        {metaTags.length > 0 &&
          metaTags.map((meta) => {
            const { id, ...metaTagsToRender } = meta
            return (
              <meta
                key={id}
                {...(metaTagsToRender as MetaHTMLAttributes<HTMLMetaElement>)}
              />
            )
          })}
        {richSnippets.length > 0 &&
          richSnippets.map((richSnippet, index) => (
            <React.Fragment key={index}>{richSnippet}</React.Fragment>
          ))}
      </Head>
      <div
        style={{ overflowX: "hidden" }}
        data-zendesk={showZendeskHelp ? "true" : "false"}
      >
        {children}
      </div>
    </>
  )
}

export default Layout
